// Controls the vertical mobile sidebar

import { delegate } from '../utils/tools';

let navigationMenuContainer = null;
let sidebarContainer = null;

function closeAllSections() {
	document.querySelectorAll('[data-js=sidebar-section]').forEach(element => {
		element.classList.remove('sidebar-section--active');
	});

	document
		.querySelectorAll('[data-js=sidebar-section-toggle]')
		.forEach(element => {
			element.classList.remove('active');
		});
}

function handleSectionClick(event) {
	let button = event.delegateTarget;
	let targetSelector = `[data-toggle-id=${button.dataset.toggleFor}]`;
	let target = document.querySelector(targetSelector);

	if (!target) {
		console.log(`could not find element matching ${targetSelector}`);
		return;
	}

	let isActive = button.classList.contains('active');

	closeAllSections();

	if (!isActive) {
		target.classList.add('sidebar-section--active');
		button.classList.add('active');
	}

	// Set aria role for mobile navigation
	if (!isActive) {
		target.setAttribute('aria-hidden', 'false');
	} else {
		target.setAttribute('aria-hidden', 'true');
	}
}

function closeMenuItems(e, item, currentTarget) {
	let isActive =
		item !== currentTarget && item.parentNode.classList.contains('active');

	if (!isActive) {
		return;
	}

	item.parentNode.classList.remove('active');
}

function maybeCloseHorizontalMenu(event) {
	// if no menu is open, stop
	let activeMenuSection = document.querySelector(
		'[data-js="sidebar-section-toggle"].active'
	);
	if (!activeMenuSection) {
		return;
	}

	// if the click originated within the menu container, stop
	if (sidebarContainer.contains(event.target)) {
		return;
	}

	// otherwise, cancel the click, and close any open menus instead
	event.preventDefault();
	closeAllSections();
}

// respond to clicks within the vertical/horizontal sidebar's "menu" structure
function handleMenuClick(event) {
	let target = event.delegateTarget;
	if (!target) {
		return;
	}

	event.preventDefault();

	let currentDepth = target.parentNode.dataset.depth;
	let depths = ['0', '1', '2'];
	let currentDepthIndex = Math.max(depths.indexOf(currentDepth), 0);

	let depthsToClose = depths.slice(currentDepthIndex);

	let selected = depthsToClose.flatMap(level => {
		let selector = `[data-depth="${level}"] > [data-sidebar-menu="menu-toggle-parent"]`;
		return [].slice.call(
			navigationMenuContainer.querySelectorAll(selector)
		);
	});

	selected.forEach(item => closeMenuItems(event, item, target));

	let childMenu = target.nextElementSibling;
	if (childMenu) {
		target.parentNode.classList.toggle('active');
	}
}

function sectionInit() {
	let sidebarWrapper = document.querySelector('[data-js="sidebar-wrapper"]');

	if (!sidebarWrapper) {
		return;
	}

	delegate(
		sidebarWrapper,
		'[data-js="sidebar-section-toggle"]',
		'click',
		handleSectionClick
	);

	console.info('Initialized department sidebar sections.');
}

function navigationMenuInit() {
	navigationMenuContainer = document.querySelector(
		'[data-js="sidebar__nav"]'
	);

	if (!navigationMenuContainer) {
		return;
	}

	let selector = '[data-sidebar-menu="menu-toggle-parent"]';
	delegate(navigationMenuContainer, selector, 'click', handleMenuClick);

	console.info('Initialized in-site navigation menu interactions.');
}

export default function init() {
	sectionInit();
	navigationMenuInit();

	sidebarContainer = document.querySelector('[data-js="sidebar-wrapper"]');

	document.addEventListener('click', maybeCloseHorizontalMenu);
}
